import {
    BoxedRow,
    EmptyState,
    Inline,
    Spinner,
    Text2,
    Text6,
    ThemeVariant,
    skinVars,
    IconQuestionRegular,
    TextLink,
    IconBoxRegular,
    Divider,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../../../utils/navigation/navigateParams';
import './index.scss';
import InfiniteScroll from 'react-infinite-scroll-component';
import { AxiosError, AxiosResponse } from 'axios';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import { managementEnvironment } from '../../../../utils/dataTransformation/environments';
import Stopper from '../../../../components/Stopper';
import { Order } from '../../../../models/Orders';
import { OrderStatusTag } from '../statusTags';
import dayjs from 'dayjs';
import { getOrders } from '../../../../services/OrderService';

export const Orders: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const ordersDisabled = managementEnvironment().REACT_APP_STOPPER_PROFILE_ORDERS_DISABLED;
    const [firstLoading, setfirstLoading] = useState(true);
    const [orders, setOrders] = useState<Order[]>([]);
    const [moreElements, setMoreElements] = useState(true);
    const [page, setPage] = useState(1);

    const sendToNative = (url: string, type: string, title: string, id?: string) => {
        const queryParams = { id };
        if (navigateParams(type, url, queryParams, {}, title)) {
            id ? navigate(`${url}?id=${id}`) : navigate(`${url}`);
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        getInfoOrders();
    }, []);

    const getInfoOrders = () => {
        getOrders({ page, size: 10 })
            .then((response: AxiosResponse) => {
                setPage(page + 1);
                setfirstLoading(false);
                setMoreElements(response.data.moreElements);
                setOrders(orders.concat(response.data.orders));
            })
            .catch((error: AxiosError) => {
                setfirstLoading(false);
            });
    };

    if (firstLoading) {
        return (
            <div className='c-spinner'>
                <Spinner size={24} />
                <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
            </div>
        );
    }

    return ordersDisabled ? (
        <Stopper></Stopper>
    ) : (
        <div className='orders-page'>
            {!(isWebviewAndroid || isWebviewIOS) && (
                <div className='orders-page__header'>
                    <ThemeVariant>
                        <Text6>{t('profileOrders')}</Text6>
                    </ThemeVariant>
                    <div
                        onClick={() =>
                            sendToNative('/profile/orders/faqs', 'modeFlow-backgroundBlue', t('orderDetail'), '')
                        }
                    >
                        <IconQuestionRegular size={24}></IconQuestionRegular>
                    </div>
                </div>
            )}
            <div className='orders-page__header__divider'>
                <Divider />
            </div>
            {!orders || orders[0] === undefined ? (
                <div className='orders-page__emptyState'>
                    <EmptyState
                        icon={<IconBoxRegular color={skinVars.colors.brand} size={64} />}
                        title={t('ordersEmptyStateTitle')}
                        description={t('ordersEmptyStateDescription')}
                    ></EmptyState>
                </div>
            ) : (
                orders?.length > 0 && (
                    <InfiniteScroll
                        dataLength={orders.length}
                        next={getInfoOrders}
                        hasMore={moreElements}
                        loader={
                            <div className='orders-page'>
                                <div
                                    className='orders-page__loading'
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        color: skinVars.colors.textSecondary,
                                        padding: '16px',
                                    }}
                                >
                                    <Inline space={8} alignItems='center'>
                                        <Spinner size={24} color={skinVars.colors.navigationBarBackground}></Spinner>
                                        {t('loading')}
                                    </Inline>
                                </div>
                            </div>
                        }
                    >
                        {orders.map((item, index) => {
                            return (
                                <div className='orders-page__orders' key={index}>
                                    <BoxedRow
                                        right={<OrderStatusTag status={item.status}></OrderStatusTag>}
                                        title={item.description}
                                        extra={
                                            <div>
                                                <div className='orders-page__extra'>
                                                    <div className='orders-page__extra-startDate'>
                                                        <Text2 regular color={skinVars.colors.textPrimary}>
                                                            {t('ordersState')}
                                                        </Text2>
                                                        <Text2 regular color={skinVars.colors.textSecondary}>
                                                            {dayjs(item.startDate as any).format('DD/MM/YYYY')}
                                                        </Text2>
                                                    </div>
                                                    {item.finishDate && (
                                                        <div className='orders-page__extra-finishDate'>
                                                            <Text2 regular color={skinVars.colors.textPrimary}>
                                                                {t('ordersTagDone')}
                                                            </Text2>
                                                            <Text2 regular color={skinVars.colors.textSecondary}>
                                                                {dayjs(item.finishDate as any).format('DD/MM/YYYY')}
                                                            </Text2>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className='orders-page__extra-link'>
                                                    <TextLink
                                                        onPress={() => {
                                                            sendToNative(
                                                                '/order-detail',
                                                                'modeFlow-backgroundBlue',
                                                                t('orderDetail'),
                                                                item.id,
                                                            );
                                                        }}
                                                    >
                                                        {t('moreInformationLink')}
                                                    </TextLink>
                                                </div>
                                            </div>
                                        }
                                    ></BoxedRow>
                                </div>
                            );
                        })}
                    </InfiniteScroll>
                )
            )}
        </div>
    );
};

export default Orders;
